import { DataPropertyType } from '@/shared/types';
import {
  V2AreaGetValveConfigListPostResponse,
  V2AreaGetAllMediumValvesPostResponse,
} from '@maxtropy/device-customer-apis-v2';

export type ValveConfigData = V2AreaGetValveConfigListPostResponse;
export type MediumItem = Exclude<V2AreaGetValveConfigListPostResponse['list'], undefined>[number];
export type ValveDevice = Exclude<MediumItem['valveDetailList'], undefined>[number];
export type SelectedMediumValves = Exclude<V2AreaGetAllMediumValvesPostResponse['list'], undefined>[number];
export type DeviceItem = {
  id: number;
  name?: string;
};

/** 判断条件操作符 */
export enum ConditionOperator {
  GreaterThan = 1,
  GreaterThanOrEqual = 2,
  LessThan = 3,
  LessThanOrEqual = 4,
}

export enum CommandStatus {
  OPEN = 1,
  CLOSE,
}

/** 判断条件 */
export interface Condition {
  operator: ConditionOperator;
  value: number;
}

/** 控制指令配置 */
export interface ValveControlConfig {
  dataPropertyId: number;
  dataPropertyName: string;
  dataPropertyType: DataPropertyType;
  /** 阀门开-枚举值 */
  openValue?: number;
  /** 阀门开-枚举名称 */
  openValueName?: string;
  /** 阀门关-枚举值 */
  closeValue?: number;
  /** 阀门关-枚举名称 */
  closeValueName?: string;
  /** 阀门开判断条件（遥测值类型） */
  openCondition?: Condition;
  /** 阀门关判断条件（遥测值类型） */
  closeCondition?: Condition;
  /** 站房组态ID */
  scadaId?: number;
  /** 站房组态名称 */
  scadaName?: string;
}

/** 按介质分组的阀门配置 */
export interface ValveMediumConfig {
  mediumId: number;
  mediumName: string;
  devices: ValveDevice[];
}
/** 站房组态选项 */
export interface StationScadaOption {
  id: number;
  airStationName: string;
  scadaId?: number;
  scadaName?: string;
}

/** 操作符选项 */
export const OPERATOR_OPTIONS = [
  { label: '>', value: ConditionOperator.GreaterThan },
  { label: '>=', value: ConditionOperator.GreaterThanOrEqual },
  { label: '<', value: ConditionOperator.LessThan },
  { label: '<=', value: ConditionOperator.LessThanOrEqual },
];
